import requestsList from './modules/store'

export const modules = {
  requestsList
}



// WEBPACK FOOTER //
// ./src/store/Requests/index.js